<div
  class="list-contrat-container background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card"
  *ngIf="!selectedContrat">
  <div class="filters-row">
    <app-search-investisseur-autocomplete
      (onInvestisseurIdSelected)="onInvestisseurIdSelected($event)"
      [isClientStatutOnly]="false">
    </app-search-investisseur-autocomplete>
    <lib-search-commande-autocomplete
      [enveloppeId]="filterEnveloppeId"
      (onCommandeSelected)="onCommandeIdSelected($event)">
    </lib-search-commande-autocomplete>
    <app-search-enveloppe-produit-autocomplete
      [enveloppeId]="filterEnveloppeId"
      (onEnveloppeSelect)="onEnveloppeIdSelected($event)"
      (onProduitSelect)="onProduitSelected($event)"
      [useSpinner]="false"></app-search-enveloppe-produit-autocomplete>
  </div>
  <div class="table">
    <app-contrats-table
      [receivedData]="requestResult"
      (requestNewPage)="getAllCommandes()"
      (onRowClicked)="onContratClick($event)"
      [(paginationParams)]="paginationParams"
      [withLoadingOnPageChange]="true"></app-contrats-table>
  </div>
</div>
<div
  class="selected-contrat-container background-white width-100pc oui-elevation-04 rounded padding-32 card"
  *ngIf="selectedContrat">
  <div class="selected-contrat-header">
    <div class="body-2" *ngIf="selectedContrat">Contrat sélectionné :</div>

    <a *ngIf="!isModifierDisabled" (click)="onModifier()">Modifier</a>
    <div *ngIf="isModifierDisabled" [ouiTooltip]="toolTipText" [ouiTooltipPosition]="toolTipPosition">
      <a class="link-disabled">Modifier</a>
    </div>
  </div>
  <div class="selected-contrat-body">
    <oui-table>
      <table class="padding-16 mingap">
        <tr>
          <td>{{ selectedInvestisseurFullName }}</td>
          <td *ngIf="selectedCoInvestisseurFullName">
            {{ selectedCoInvestisseurFullName }}
          </td>
          <td>
            <div class="flex-vertical">
              <div class="body-2 color-on-surface-emphasis">
                N° {{ selectedContrat.numeroContrat ?? 'non renseigné' }}
              </div>
              <div class="caption color-on-surface-medium">
                {{
                  selectedContrat.dateActe
                    ? 'le ' + (selectedContrat.dateActe | date : 'dd-MM-yyyy')
                    : 'date non renseignée'
                }}
              </div>
            </div>
          </td>
          <td>
            <div class="flex-vertical">
              <div class="body-2 color-on-surface-emphasis">
                {{ selectedContrat.produit.nomTechniqueProduitBox ?? selectedContrat.produit.nom }}
              </div>
            </div>
          </td>
        </tr>
      </table>
    </oui-table>
    <oui-banner
      type="complex"
      title="Les données relatives à ce produit ne sont pas encore disponibles."
      declination="error"
      description="
        Si vous pensez qu'il s'agit d'un oubli, merci de contacter le support afin de demander leur ajout.
      "
      [action]="ContacterSupportAction"
      *ngIf="!configProduitExists"
      [showCloseButton]="false"></oui-banner>
    <oui-banner
      title="Après cette étape vous ne pourrez plus changer le contrat sélectionné."
      [showCloseButton]="false"></oui-banner>
  </div>
</div>
